export const menuTabs = {
  home: 'Home',
  repairs: 'Repairs',
  parts: 'Parts',
  quickAssist: 'Quick Assist',
  VINScanner: 'VIN Scanner',
  profile: 'Profile',
  notifications: 'Notifications',
  help: 'Help',
  logOut: 'LogOut',
} as const;
